import { Component } from '@angular/core';

@Component({ templateUrl: './reason-shell.component.html' })
export class ReasonShellComponent {}
